
import Vue from 'vue'
import ContactUsPage from './components/ContactUsPage.vue'

export default Vue.extend({
   name: 'SiteContactUsApp',
   components: {
      ContactUsPage,
   },
})
